import React from "reactn";
import styled from "styled-components";
import {
    Select,
    MenuItem
} from "@material-ui/core";

const Frame = styled.div`
  padding: 0px 10px;
  display: flex;
  align-items: center;

  >div:first-child {
    padding-left: 10px;
  }
  
  &:before {
    content: "";
    width: 1px;
    height: 50%;
    background: #DBDBDB;
  }
`;

const StyledSelect = styled(Select)`
  &&& {
    .MuiSelect-select {
      color: #444;
      font-family: "Source Sans Pro";
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 15px;
      text-transform: uppercase;
      background: transparent;

      &:focus {
        background: transparent;
      }
    }
  }
`;

export function FilterDropDown({ filterOptions, onChange, selectedFilter, className = "" }) {
    return (
        <Frame className={className}>
            <StyledSelect
                onChange={onChange}
                value={selectedFilter}
                disableUnderline
            >
                {
                    filterOptions.map(filter => {
                        const field = filter.field ?? filter.id;
                        const label = filter.label ?? filter.name;
                        return (
                            <MenuItem
                                disableGutters
                                key={field}
                                value={field}
                            >
                                {label}
                            </MenuItem>
                        );
                    })
                }
            </StyledSelect>
        </Frame>
    );
}
